@if (analytics.asking()) {
  <!-- Only the card takes the pointer, so the app around it stays clickable while it asks. -->
  <div
    class="pointer-events-none fixed inset-x-0 bottom-0 z-[60] px-8 pb-8"
    role="dialog"
    aria-label="Cookie consent"
    aria-live="polite"
  >
    <div
      class="pointer-events-auto mx-auto flex max-w-[960px] flex-col gap-8 rounded-xl border border-border bg-white p-10 shadow-panel sm:flex-row sm:items-center sm:justify-between"
    >
      <p class="text-sm text-secondary-800">
        We use cookies to run Stitch.ai and, with your consent, to understand how the site is used. See our
        <a class="font-semibold underline" [href]="cookiePolicyUrl" target="_blank" rel="noopener">cookie policy</a>.
      </p>
      <div class="flex shrink-0 gap-6">
        <app-button2 appearance="secondary" (click)="analytics.optOut()">Decline non-essential</app-button2>
        <app-button2 appearance="primary" (click)="analytics.optIn()">Accept all</app-button2>
      </div>
    </div>
  </div>
}
